<div class="dialog-container">
  <b class="dialog-title">{{config.title}}</b>
  <div class="dialog-content">
    <p [innerHTML]="config.text"></p>
    <div *ngIf="config.inputEnabled" class="ts-form-field tp-full-width">
      <input class="ts-input tp-full-width" maxlength="{{config.maxInputLength}}" autocomplete="off" [(ngModel)]="inputValue">
      <span class="dialog-hint">{{inputValue.length}} / {{config.maxInputLength}}</span>
    </div>
  </div>
  <div class="dialog-actions">
    <button class="btn-outlined" (click)="onCancelClick()" [hidden]="config.isAlertDialog">{{config.cancelText}}</button>
    <button class="btn-primary" (click)="onConfirmClick(inputValue)" [disabled]="!isValidForm(inputValue)" autofocus>{{config.confirmText}}</button>
  </div>
</div>
